import { ReactElement, useMemo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import classNames from 'clsx';
import styles from './product-test-rating.component.module.scss';

type ProductTestRatingComponentVariant = 'standalone' | 'product-media' | 'product-tile';

export interface ProductTestRatingComponentProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'children'
> {
  readonly source: string;
  readonly alt: string;
  readonly variant?: ProductTestRatingComponentVariant;
}

export default function ProductTestRatingComponent({
  source,
  alt,
  variant = 'standalone',
  className,
  ...props
}: ProductTestRatingComponentProps): ReactElement {
  const sizes = useMemo(() => {
    switch (variant) {
      case 'standalone':
        return '(min-width: 768px) 300px, 100px';
      case 'product-media':
        return '(min-width: 768px) 300px, 60px';
      case 'product-tile':
        return '(min-width: 768px) 105px, 50px';
    }
  }, [variant]);

  return (
    <figure
      className={classNames(
        styles['product-test-rating'],
        {
          [styles['product-test-rating--standalone']]: variant === 'standalone',
          [styles['product-test-rating--product-media']]: variant === 'product-media',
          [styles['product-test-rating--product-tile']]: variant === 'product-tile'
        },
        className
      )}
      {...props}
    >
      <ImageComponent
        fill
        alt={alt}
        className={classNames(styles['product-test-rating__image'], {
          [styles['product-test-rating__image--standalone']]: variant === 'standalone',
          [styles['product-test-rating__image--product-media']]: variant === 'product-media',
          [styles['product-test-rating__image--product-tile']]: variant === 'product-tile'
        })}
        sizes={sizes}
        src={source}
      />
    </figure>
  );
}
